
import Vue from 'vue'

export default Vue.extend({
    data: () => {
        return {
            recentBlocks: null as Connex.Thor.Block[] | null,
            recentTransfers: null as Connex.Thor.Filter.Row<'transfer', { id: string }>[] | null,
            loadingBlocks: false,
            loadingTransfers: false,
            searchString: '',
            bandwidthChartLoaded: false
        }
    },
    computed: {
        head() {
            return this.$state.chainStatus!.head
        }
    },
    methods: {
        reload() {
            this.loadRecentBlocks()
            this.loadRecentTransfers()
        },
        async loadRecentBlocks() {
            if (this.loadingBlocks || this.head.number === 0) {
                return
            }
            try {
                this.loadingBlocks = true
                const headNum = this.head.number
                const requests: Array<Promise<Connex.Thor.Block | null>> = []
                for (let i = headNum; i >= Math.max(headNum - 4, 0); i--) {
                    requests.push(this.$connex.thor.block(i).get())
                }

                const blocks = await Promise.all(requests)
                if (blocks.every(b => !!b)) {
                    this.recentBlocks = blocks as any
                }
            } catch (err) {
                console.warn(err)
            } finally {
                this.loadingBlocks = false
            }
        },
        async loadRecentTransfers() {
            if (this.loadingTransfers) {
                return
            }
            try {
                this.loadingTransfers = true
                const result = await this.$connex.thor
                    .filter('transfer', [])
                    .order('desc')
                    .apply(0, 10)
                let counter = 0
                let lastBlockID = ''
                this.recentTransfers = result.map(t => {
                    if (lastBlockID !== t.meta!.blockID) {
                        counter = 0
                        lastBlockID = t.meta.blockID
                    }
                    const id = t.meta!.blockID + counter
                    counter++
                    lastBlockID = t.meta!.blockID
                    return {
                        id,
                        ...t
                    }
                })
            } catch (err) {
                console.warn(err)
            } finally {
                this.loadingTransfers = false
            }
        },
        search() {
            const str = this.searchString.trim()
            this.searchString = ''
            if (!str) {
                return
            }
            this.$router.push({ name: 'search', query: { q: str } })
        }
    },
    watch: {
        head() {
            this.reload()
        }
    },
    created() {
        this.$ga.page('/insight/home')
        this.reload()
    }
})
